



























// Define the component in class-style
import Component from "vue-class-component";
import Vue from "vue";
import { Prop, VModel } from "vue-property-decorator";
import { value } from "@/models/CustomTypes";

@Component
export default class TimeInput extends Vue {
  @Prop({ default: "Data" }) label: string;
  @Prop({ default: false }) disabled: boolean;
  @VModel({ type: [String, Object] }) localValue: value;
  @Prop({ default: [] }) rules: [];
  modal = false;
}
